const reposition = (elm, pos) => {
  const element = elm;
  element.style.left = `${pos.left}px`;
  element.style.width = `calc(100% - ${pos.left}px)`;
};

const gallery = () => {
  const galleries = document.querySelectorAll(
    '[data-gallery-postion-reference]',
  );
  if (galleries.length) {
    // eslint-disable-next-line no-plusplus
    for (let i = 0; i < galleries.length; i++) {
      const referenceElm = galleries[i];
      const referencePos = referenceElm.getBoundingClientRect();
      const referenceID = referenceElm.getAttribute(
        'data-gallery-postion-reference',
      );
      const singleGallery = document.querySelector(
        `[data-gallery="${referenceID}"]`,
      );

      reposition(singleGallery, referencePos);
    }
  }
};

gallery();

window.addEventListener('resize', gallery);
